import { RadioGroup } from '@platform/components';
import { CompletedOutcomes, UpdateDiscoveryCallFormData } from '.';
import { FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form';

type OutcomeSelectionContentProps = {
  otherPartyName: string;
  register: UseFormRegister<UpdateDiscoveryCallFormData>;
  setValue: UseFormSetValue<UpdateDiscoveryCallFormData>;
  formState: FormState<UpdateDiscoveryCallFormData>;
  selectedOutcome: CompletedOutcomes | undefined | null;
};
export const OutcomeSelectionContent = (props: OutcomeSelectionContentProps) => {
  return (
    <div className='flex flex-col gap-8 items-center md:mt-8 md:w-[500px]'>
      <div className='text-center text-xl'>
        Great! Do you want to match with {props.otherPartyName}?
      </div>
      <div className='mt-4 w-full'>
        <RadioGroup
          name='outcome-selection'
          aria-label='outcome-reason'
          items={[
            {
              value: CompletedOutcomes.Accepted,
              title: "Yes, it's the right fit",
            },
            {
              value: CompletedOutcomes.Declined,
              title: "No, it's not a good fit",
            },
            {
              value: CompletedOutcomes.Need_Help,
              title: 'I need help deciding',
            },
          ]}
          onChange={(value) => {
            props.setValue('outcome', value as CompletedOutcomes, { shouldValidate: true });
          }}
          register={() => props.register('outcome', { required: 'Select one option to continue' })}
          defaultValue={props.selectedOutcome ?? undefined}
          error={props.formState.errors.outcome?.message}
        />
      </div>
    </div>
  );
};
